import { AbstractControl, ValidationErrors } from '@angular/forms';
import { debounceTime, map, Observable } from 'rxjs';
import { ValidateReferralGQL } from '../../_graphql/generated';
import { inject, Injector, runInInjectionContext } from '@angular/core';

export function referralValidator(
  control: AbstractControl,
): ValidationErrors | null {
  return !control.value || /^[a-zA-Z0-9_-]+$/.test(control.value)
    ? null
    : { referral: true };
}
